export default "__VITE_ASSET__CvPE0rlO__"